import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, MenuItem } from '@material-ui/core';

import AddVersion from '../AddVersion';

import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import { lime } from '@material-ui/core/colors';
import Modal from '../../components/Modal';
import GreenCard from '../../components/GreenCard';

import { setCarInsurance, setValidCar } from '../../redux/carInsurance';

import { useFormik } from 'formik';

const builInitialValues = () => {
  let carInfo = {
    carModel: '',
  };
  return carInfo;
};

export default function AddModel(props) {
  const { nextWasRequired, dataAutos, brandId } = props;

  // Checking brand card selected for disabled model input
  const { brandSelected } = useSelector(({ carInsurance }) => ({
    brandSelected: carInsurance?.userCarInsurance?.carBrand
  }));

  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const onClick = () => {
    setOpen(true);
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  const renderModal = () => {
    return <GreenCard closeModal={closeModal} />;
  };

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carBrand: carInsurance.userCarInsurance.carBrand,
    carModel: carInsurance.userCarInsurance.carModel,
    carYear: carInsurance.userCarInsurance.carYear,
  }));

  const initialValues = builInitialValues(userCarInsurance);

  const { values, errors, touched, setFieldValue, handleBlur } = useFormik({
    initialValues,
  });

  // useEffect(() => {
  //   const validationErrors = Object.keys(errors).length > 0;
  //   const valuesRequired = values.carModel && true;

  //   if (!validationErrors && valuesRequired) {
  //     dispatch(setValidCar({ isValid: true }));
  //   }
  //   if (validationErrors || !valuesRequired) {
  //     dispatch(setValidCar({ isValid: false }));
  //   }
  // }, [values, errors]);

  const hasError = (input, inputValue) =>
    (touched[input] && errors[input]) || (nextWasRequired && inputValue === '');

  const error = 'campo obligatorio';

  useEffect(() => {
    values.carModel = '';
    if (brandId) {
      values.carModel = '';
    }
  }, [brandId]);

  function handleChange(e) {
    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));
    let carModelName = dataAutos.vehicleBrand
      .filter((e) => e.vehicleBrandId === brandId)[0]
      .vehicleGroups.find((e) => e.vehicleGroupId === value).description;
    dispatch(setCarInsurance({ carModelName: carModelName }));
  }

  return (
    <>
      {open && <Modal>{renderModal()}</Modal>}
      <div className='input-field col s10 l4'>
        <Select
          defaultValue=''
          value={values.carModel}
          id='carModel'
          name='carModel'
          type='text'
          className={`validate inputField ${
            hasError('carModel', values.carModel) ? 'error' : ''
          }`}
          classes={{ root: 'menuSelect', icon: 'caret' }}
          inputProps={{
            classes: {
              icon: 'caret',
            },
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={ dataAutos && brandSelected ? false : true }
        >
          {dataAutos &&
            brandId &&
            dataAutos.vehicleBrand
              .filter((e) => e.vehicleBrandId === brandId)
              .map((e) => e.vehicleGroups)[0]
              .map((item, key) => {
                return (
                  <MenuItem key={key} value={item.vehicleGroupId}>
                    {item.description}
                  </MenuItem>
                );
              })}
        </Select>

        <span htmlFor='carModel'>Modelo</span>
        <p className='error-text error-selected'>
          {hasError('carModel', values.carModel) && error}
        </p>
      </div>
      <div className='col s2 l2 icon-help'>
        <div onClick={onClick}>
          <HelpOutlineRoundedIcon style={{ color: lime[600] }} />
        </div>
      </div>
      <AddVersion
        nextWasRequired={nextWasRequired}
        modelId={userCarInsurance.carModel !== '' && userCarInsurance.carModel}
      />
    </>
  );
}
